export default __webpack_public_path__ + "static/media/MY.f8b3b008.svg";